import { animation } from "./_animation.js";
import { common } from "./_common.js";
import { customSplide } from "./_splide.js";
import { accordion } from "./_accordion.js";
animation();
common();
customSplide();
accordion();
